// link router
import { Link } from "react-router-dom";

// constanst
import constants from "../../../constants/footer";

import foot1 from "../../../assets/images/statics/corporate-licence.png";
// import foot2 from "../../../assets/images/statics/isolicence.png";
// import foot3 from "../../../assets/images/statics/ncomn.png";
// import foot4 from "../../../assets/images/statics/nuprc.png";
// import foot5 from "../../../assets/images/statics/sme.png";
import ios from "../../../assets/images/svgs/istore.svg";
import android from "../../../assets/images/svgs/gplay.svg";
import logo from "../../../assets/images/icons/logo.png";
import NewsletterSubscribe from "../../../components/elements/form/NewsLetterSubscribe";

type isHidden = {
  isHidden: boolean;
};

const Footer: React.FC<isHidden> = ({ isHidden = false }) => {
  // const [email, emailSet] = React.useState("");
  const currentYear = new Date().getFullYear();
  return (
    <footer
      className={`bg-gray-900 text-gray-200 w-full ${
        isHidden ? "hidden" : "block"
      }`}
    >
      {/* Email newsletter section */}
      <NewsletterSubscribe />

      {/* Divider line */}

      <hr className="border-1 border-dark/10 shadow-sm" />

      {/* Footer navigation section */}
      <div className="max-w-7xl mx-auto px-6 py-10">
        {/* Company info & navigation */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Footer Company info */}
          <div className="flex flex-col items-center md:items-start space-y-3">
            <img
              src={logo}
              className="h-12 lg:h-[70px] object-cover"
              alt="corporate Logo"
            />
            <p className="text-white/70 text-sm md:text-lg">
              Experts in complete business setup solutions.
            </p>
            <div className="flex items-center mt-4 space-x-6 sm:justify-center md:mt-0">
              {constants.social.map((item, index) => (
                <a
                  key={index + 1}
                  href={item.link}
                  className="cursor-pointer"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <item.icon
                    size={24}
                    className="text-white/70 hover:text-primary-700 hover:scale-110 transition-all duration-300"
                  />
                </a>
              ))}
            </div>
          </div>

          {/* Footer navigation links */}
          <div>
            <h3 className="mb-6 text-md font-semibold text-white">
              Quick Links
            </h3>
            <ul className="text-md md:text-lg">
              {constants.flinks.map((item) => (
                <li className="mb-3" key={item.title}>
                  <Link
                    to={item.link}
                    className="text-white/70 hover:text-primary-700"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-6 text-md font-semibold text-white">Company</h3>
            <ul className="text-md md:text-lg">
              {constants.fcompany.map((item) => (
                <li className="mb-3" key={item.title}>
                  <Link
                    to={item.link}
                    className="text-white/70 hover:text-primary-700"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-6 text-md font-semibold text-white">Legal</h3>
            <ul className="text-md md:text-lg">
              {constants.flegal.map((item) => (
                <li className="mb-3" key={item.title}>
                  <Link
                    to={item.link}
                    className="text-white/70 hover:text-primary-700"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* App download section */}
      <div className="max-w-7xl mx-auto px-6 mb-10">
        <div className="flex flex-col md:flex-row items-center space-x-3">
          <div>
            <h3 className="text-white mx-2 mb-2">
              Also available on mobile devices
            </h3>
          </div>
          <div className="flex space-x-4 items-center">
            <button className="cursor-pointer">
              <img
                loading="lazy"
                className="h-12 w-full"
                src={android}
                alt="Android App Download Link"
                decoding="async"
              />
            </button>

            <button className="cursor-pointer">
              <img
                loading="lazy"
                className="h-12 w-full"
                src={ios}
                alt="IOS App Download Link"
                decoding="async"
              />
            </button>
          </div>
        </div>
      </div>

      {/* Copyright & License section */}
      <div className="bg-gray-700">
        <div className="max-w-7xl mx-auto p-6 flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center lg:justify-between">
          <span className="text-sm text-white/70 sm:text-center">
            © {currentYear}{" "}
            <Link to="#" className="text-white">
              Corporate Set-up
            </Link>
            . All Rights Reserved.
          </span>
          <div className="flex mt-4 space-x-3 sm:justify-center md:mt-0">
            <img
              loading="lazy"
              decoding="async"
              className="w-12 h-12 lg:w-20 lg:h-20"
              src={foot1}
              alt="Business Licences"
            />
{/*             <img
              loading="lazy"
              decoding="async"
              className="w-12 h-12 lg:w-20 lg:h-20"
              src={foot2}
              alt="ISO Licences"
            />
            <img
              loading="lazy"
              decoding="async"
              className="w-12 h-12 lg:w-20 lg:h-20"
              src={foot3}
              alt="NCOMN"
            />
            <img
              loading="lazy"
              decoding="async"
              className="w-12 h-12 lg:w-20 lg:h-20"
              src={foot4}
              alt="NUPRC"
            />
            <img
              loading="lazy"
              decoding="async"
              className="w-full h-12 lg:h-20"
              src={foot5}
              alt="SME"
            /> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
